import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "send-modal__header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "send-modal__modal-title" }, "Send Survey", -1)
const _hoisted_3 = { class: "send-modal__send-survey-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "send-modal__recipients-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "send-modal__recipients-title" }, "Recipients: "),
  /*#__PURE__*/_createTextVNode("(Separate individuals with a comma)")
], -1)
const _hoisted_5 = { class: "send-modal__recipients-validation" }
const _hoisted_6 = {
  key: 1,
  class: "send-modal__valid-icon"
}
const _hoisted_7 = {
  key: 2,
  class: "send-modal__valid-icon"
}
const _hoisted_8 = { class: "send-modal__button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_valid_icon = _resolveComponent("valid-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_invalid_icon = _resolveComponent("invalid-icon")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    show: _ctx.showModalRef,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModalRef) = $event)),
    preset: "card",
    title: "Dialog",
    class: "send-modal",
    "block-scroll": false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, "Send " + _toDisplayString(_ctx.surveyNameRef), 1)
      ])
    ]),
    action: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_n_button, {
          class: "send-button",
          type: "primary",
          onClick: _ctx.onPositiveClick,
          loading: _ctx.sendingRef,
          disabled: !_ctx.validEmailRef || _ctx.sendingRef,
          "aria-disabled": !_ctx.validEmailRef || _ctx.sendingRef,
          "aria-busy": _ctx.sendingRef
        }, {
          default: _withCtx(() => [
            _createTextVNode("Send")
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled", "aria-disabled", "aria-busy"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_n_space, {
        vertical: "",
        class: "inputs"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createVNode(_component_n_input, {
            type: "textarea",
            autosize: {
          minRows: 10,
          maxRows: 20
        },
            value: _ctx.emails,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emails) = $event)),
            placeholder: `Enter emails to send ${_ctx.surveyNameRef} to.`
          }, null, 8, ["value", "placeholder"]),
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.emailList.length) + " Recipients", 1),
            (_ctx.duplicatesRemoved > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" · Duplicates removed: " + _toDisplayString(_ctx.duplicatesRemoved), 1)
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode(" |   "),
            (_ctx.validEmailRef && _ctx.emailList.length !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createVNode(_component_n_icon, { class: "valid-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_valid_icon)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" All appear valid ")
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createVNode(_component_n_icon, { class: "invalid-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_invalid_icon)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Invalid entry ")
                ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}